import { createSlice } from '@reduxjs/toolkit'
import {
  fetchAllCurrencies,
  fetchAllTransactions,
  fetchTransactionReport
} from 'redux-thunk/thunk/Transactions/transactions'

const initialState = {
  allTransactions: null,
  allCurrencies: null,
  report: null
}

const transactionSlice = createSlice({
  name: 'transactionSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          allTransactions: action.payload
        }
      })
      .addCase(fetchAllCurrencies.fulfilled, (state, action) => {
        return {
          ...state,
          allCurrencies: action.payload
        }
      })
      .addCase(fetchTransactionReport.fulfilled, (state, action) => {
        return {
          ...state,
          report: action.payload
        }
      })
  }
})

export default transactionSlice.reducer
